import React from 'react';
import {
	Accordion,
	AccordionItem,
	AccordionButton,
	AccordionPanel,
	AccordionIcon,
	Box,
	Button,
	Flex,
	Heading,
	Stack,
	Spacer,
	Tooltip,
} from '@chakra-ui/react';
import { CloseIcon } from '@chakra-ui/icons';

import { ProfileField } from '../elements/ProfileField';
import { ProfileSelect } from '../elements/ProfileSelect';
import { EEducation } from './eeducation';
import { Experience } from './experience';
import { Addresses } from './adresses';
import { Trips } from './trips';
import { Relatives } from './relatives';
import { expressEntry } from '../data';
import { makeFields } from './utils';

export const Ext = ({ state, setter, id, remove, onBlur }) => {
	const {
		lastName,
		previousNames,
		firstName,
		birthDate,
		birthPlace,
		zip,
		address,
		citizenship,
		maritalStatus,
		phoneNumber,
		eyesColor,
		height,
		emergencyContactLastName,
		emergencyContactfirstName,
		emergencyContactPhoneNumber,
		emergencyContactEmail,
		priorVisaApplications,
		priorVisaRefusals,
		priorMarriages,
		financialInfo,
		armyService,
		criminality,
		priorRefugee,
		partyMembership,
		provinceToLive,
		cityToLive,
	} = makeFields(state, setter, expressEntry, onBlur);

	const educationSubState = state.education;
	const setEducation = education => {
		setter({ ...state, education });
	};
	const education = {
		state: educationSubState,
		setter: setEducation,
		onBlur,
	};

	const experienceSubState = state.experience;
	const setExperience = experience => {
		setter({ ...state, experience });
	};
	const experience = {
		state: experienceSubState,
		setter: setExperience,
		onBlur,
	};

	const addressesSubState = state.adresses;
	const setAdresses = adresses => {
		setter({ ...state, adresses });
	};
	const addresses = {
		state: addressesSubState,
		setter: setAdresses,
		onBlur,
	};

	const tripsSubState = state.trips;
	const setTrips = trips => {
		setter({ ...state, trips });
	};
	const trips = {
		state: tripsSubState,
		setter: setTrips,
		onBlur,
	};

	const relativesSubState = state.relatives;
	const setRelatives = relatives => {
		setter({ ...state, relatives });
	};
	const relatives = {
		state: relativesSubState,
		setter: setRelatives,
		onBlur,
	};

	return (
		<Box borderRadius="md" border="1px" borderColor="gray.200" p={4} mb={4}>
			<Flex>
				<Heading pb={6} fontSize={'lg'}>
					{`${state.firstName || 'Имя'} ${state.lastNames || 'Фамилия'}`}
				</Heading>
				<Spacer />
				<Button
					leftIcon={<CloseIcon />}
					colorScheme="red"
					variant="solid"
					size="xs"
					name={id}
					onClick={remove}
				>
					Удалить
				</Button>
			</Flex>
			<Accordion allowToggle>
				<AccordionItem>
					<h2>
						<AccordionButton>
							<Tooltip label="Персональная информация" placement="top-start">
								<Heading fontSize="lg" flex="1" textAlign="left">
									Personal information
								</Heading>
							</Tooltip>
							<AccordionIcon />
						</AccordionButton>
					</h2>
					<AccordionPanel pb={4}>
						<Stack direction={['column', 'row']}>
							<ProfileField pb={6} {...firstName} />
							<ProfileField pb={6} {...lastName} />
							<ProfileField pb={6} {...previousNames} />
						</Stack>
						<Stack direction={['column', 'row']}>
							<ProfileField pb={6} {...birthDate} />
							<ProfileField pb={6} {...birthPlace} />
						</Stack>
						<Stack direction={['column', 'row']}>
							<ProfileField w={['100%', '15%']} pb={6} {...zip} />
							<ProfileField w={['100%', '85%']} pb={6} {...address} />
						</Stack>
						<Stack direction={['column', 'row']}>
							<ProfileSelect pb={6} {...citizenship} />
							<ProfileSelect pb={6} {...maritalStatus} />
						</Stack>
						<Stack direction={['column', 'row']}>
							<ProfileField pb={6} {...phoneNumber} />
							<ProfileField pb={6} {...eyesColor} />
							<ProfileField pb={6} {...height} />
						</Stack>
						<Tooltip
							label="Контактное лицо для экстренных случаев"
							placement="top-start"
						>
							<Heading fontSize="lg" pb={6}>
								Contact person in case of emergency
							</Heading>
						</Tooltip>
						<Stack direction={['column', 'row']}>
							<ProfileField pb={6} {...emergencyContactLastName} />
							<ProfileField pb={6} {...emergencyContactfirstName} />
						</Stack>
						<Stack direction={['column', 'row']}>
							<ProfileField pb={6} {...emergencyContactPhoneNumber} />
							<ProfileField pb={6} {...emergencyContactEmail} />
						</Stack>
					</AccordionPanel>
				</AccordionItem>

				<AccordionItem>
					<h2>
						<AccordionButton>
							<Tooltip
								label="Образование (школы/колледжи/университеты – указать необходимо ВСЕ)"
								placement="top-start"
							>
								<Heading fontSize="lg" flex="1" textAlign="left">
									All Completed Education
								</Heading>
							</Tooltip>
							<AccordionIcon />
						</AccordionButton>
					</h2>
					<AccordionPanel pb={4}>
						<EEducation {...education} />
					</AccordionPanel>
				</AccordionItem>

				<AccordionItem>
					<h2>
						<AccordionButton>
							<Tooltip label="Весь опыт работы" placement="top-start">
								<Heading fontSize="lg" flex="1" textAlign="left">
									Work Experience
								</Heading>
							</Tooltip>
							<AccordionIcon />
						</AccordionButton>
					</h2>
					<AccordionPanel pb={4}>
						<Experience {...experience} />
					</AccordionPanel>
				</AccordionItem>

				<AccordionItem>
					<h2>
						<AccordionButton>
							<Tooltip
								label="Адреса проживания за последние 10 лет"
								placement="top-start"
							>
								<Heading fontSize="lg" flex="1" textAlign="left">
									Residence addresses for last 10 years
								</Heading>
							</Tooltip>
							<AccordionIcon />
						</AccordionButton>
					</h2>
					<AccordionPanel pb={4}>
						<Addresses {...addresses} />
					</AccordionPanel>
				</AccordionItem>

				<AccordionItem>
					<h2>
						<AccordionButton>
							<Tooltip
								label="Поездки за границу за последние 10 лет (день/месяц/год)"
								placement="top-start"
							>
								<Heading fontSize="lg" flex="1" textAlign="left">
									Abroad trips for last 10 years
								</Heading>
							</Tooltip>
							<AccordionIcon />
						</AccordionButton>
					</h2>
					<AccordionPanel pb={4}>
						<Trips {...trips} />
					</AccordionPanel>
				</AccordionItem>

				<AccordionItem>
					<h2>
						<AccordionButton>
							<Tooltip
								label="Данные о семье (родители, дети (если не иммигрируют с вами), сестры, братья)"
								placement="top-start"
							>
								<Heading fontSize="lg" flex="1" textAlign="left">
									Family information
								</Heading>
							</Tooltip>
							<AccordionIcon />
						</AccordionButton>
					</h2>
					<AccordionPanel pb={4}>
						<Relatives {...relatives} />
					</AccordionPanel>
				</AccordionItem>

				<AccordionItem>
					<h2>
						<AccordionButton>
							<Tooltip
								label="Информация о значимых для иммиграции фактах"
								placement="top-start"
							>
								<Heading fontSize="lg" flex="1" textAlign="left">
									Immigration information
								</Heading>
							</Tooltip>
							<AccordionIcon />
						</AccordionButton>
					</h2>
					<AccordionPanel pb={4}>
						<Stack direction={['column', 'row']}>
							<ProfileField pb={6} {...priorVisaApplications} />
						</Stack>
						<Stack direction={['column', 'row']}>
							<ProfileField pb={6} {...priorVisaRefusals} />
						</Stack>
						<Stack direction={['column', 'row']}>
							<ProfileField pb={6} {...priorMarriages} />
						</Stack>
						<Stack direction={['column', 'row']}>
							<ProfileField pb={6} {...financialInfo} />
						</Stack>
						<Stack direction={['column', 'row']}>
							<ProfileField pb={6} {...armyService} />
							<ProfileField pb={6} {...criminality} />
						</Stack>
						<Stack direction={['column', 'row']}>
							<ProfileField pb={6} {...priorRefugee} />
							<ProfileField pb={6} {...partyMembership} />
						</Stack>
						<Stack direction={['column', 'row']}>
							<ProfileSelect pb={6} {...provinceToLive} />
							<ProfileField pb={6} {...cityToLive} />
						</Stack>
					</AccordionPanel>
				</AccordionItem>
			</Accordion>
		</Box>
	);
};
